 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		56: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"1":"account","2":"locks","3":"my-identity","6":"japan","7":"monaco","8":"ukraine","9":"afghanistan","10":"albania","11":"algeria","12":"american-samoa","13":"andorra","14":"angola","15":"anguilla","16":"antigua-and-barbuda","17":"argentina","18":"armenia","19":"aruba","20":"australia","21":"austria","22":"azerbaijan","23":"bahamas","24":"bahrain","25":"barbados","26":"belarus","27":"belgium","28":"belize","29":"benin","30":"bermuda","31":"bhutan","32":"bolivia","33":"bonaire","34":"bosnia-and-herzegovina","35":"botswana","36":"brazil","37":"british-indian-ocean-territory","38":"british-virgin-islands","39":"brunei","40":"bulgaria","41":"burkina-faso","42":"burundi","43":"cambodia","44":"cameroon","45":"canada","46":"cape-verde","47":"casino","48":"casino-category","49":"casino-navigation","50":"cayman-islands","51":"central-african-republic","52":"chad","53":"chile","54":"china","55":"christmas-island","57":"client-error-page","58":"colombia","59":"comoros","60":"cook-islands","61":"costa-rica","62":"croatia","63":"cuba","64":"curacao","65":"cyprus","66":"czech-republic","67":"denmark","68":"djibouti","69":"dominica","70":"dominican-republic","71":"east-timor","72":"ecuador","73":"egypt","74":"equatorial-guinea","75":"eritrea","76":"estonia","77":"ethiopia","78":"falkland-islands","79":"faq","80":"faq-page","81":"faroe-islands","82":"field-response","83":"fiji","84":"finland","85":"france","86":"free-text","87":"french-polynesia","88":"gabon","89":"gambia","90":"gambling-history","91":"game-page","92":"georgia","93":"germany","94":"ghana","95":"gibraltar","96":"greece","97":"greenland","98":"grenada","99":"guam","100":"guatemala","101":"guernsey","102":"guinea","103":"guinea-bissau","104":"guyana","105":"haiti","106":"honduras","107":"hong-kong","108":"hungary","109":"iceland","110":"india","111":"info-page","112":"iran","113":"iraq","114":"ireland","115":"isle-of-man","116":"israel","117":"italy","118":"ivory-coast","119":"jamaica","120":"jersey","121":"jordan","122":"kazakhstan","123":"kenya","124":"kiribati","125":"kosovo","126":"kuwait","127":"kyrgyzstan","128":"laos","129":"latvia","130":"lebanon","131":"lesotho","132":"liberia","133":"libya","134":"liechtenstein","135":"lithuania","136":"live-casino","137":"lock-page-container","138":"login-box","139":"login-drawer","140":"login-form","141":"logo","142":"logout","143":"luxembourg","144":"macao","145":"madagascar","146":"mahjong","147":"malawi","148":"malaysia","149":"maldives","150":"mali","151":"malta","152":"martinique","153":"mauritania","154":"mauritius","155":"mexico","156":"micronesia","157":"moldova","158":"mongolia","159":"montenegro","160":"montserrat","161":"morocco","162":"mozambique","163":"my-identity-faq","164":"namibia","165":"nauru","166":"nepal","167":"netherlands","168":"new-zealand","169":"nicaragua","170":"niger","171":"nigeria","172":"niue","173":"norfolk-island","174":"north-korea","175":"norway","176":"not-found","177":"oman","178":"pakistan","179":"palestine","180":"panama","181":"papua-new-guinea","182":"paraguay","183":"password-recovery","184":"password-reset","185":"perks-page","186":"peru","187":"philippines","188":"phone-verification-drawer","189":"picked-games-page","190":"picked-games-picker","191":"picked-games-search-results","192":"pitcairn-islands","193":"portugal","194":"primary","195":"promotion-terms-and-conditions-page","196":"puerto-rico","197":"qatar","198":"receipts","199":"republic-of-the-congo","200":"romania","201":"russia","202":"rwanda","203":"saint-kitts-and-nevis","204":"samoa","205":"san-marino","206":"saudi-arabia","207":"search-bar","208":"search-page","209":"search-provider","210":"search-results","211":"senegal","212":"serbia","213":"seychelles","214":"sierra-leone","215":"singapore","216":"sint-maarten","217":"slovakia","218":"slovenia","219":"solomon-islands","220":"somalia","221":"source-of-funds","222":"south-africa","223":"south-korea","224":"south-sudan","225":"spain","226":"sri-lanka","227":"static-page","228":"sudan","229":"suriname","230":"swaziland","231":"sweden","232":"switzerland","233":"syria","234":"taiwan","235":"tajikistan","236":"tanzania","237":"terms-and-conditions","238":"terms-and-conditions-consent","239":"thailand","240":"togo","241":"tokelau","242":"tonga","243":"trinidad-and-tobago","244":"tunisia","245":"turkey","246":"turkmenistan","247":"tuvalu","248":"uganda","249":"united-arab-emirates","250":"united-kingdom","251":"unknown","252":"uruguay","253":"uzbekistan","254":"vanuatu","255":"vatican-city","256":"venezuela","257":"vietnam","258":"vip-page","259":"western-sahara","260":"worldwide","261":"yemen","262":"zambia","263":"zimbabwe"}[chunkId]||chunkId) + "." + {"0":"22c98d2c","1":"9d2dadfd","2":"d08e9227","3":"3d17741a","4":"f72f91d4","5":"193a608f","6":"e2e199a1","7":"13ba6cb0","8":"6604cc4f","9":"ebbd93ff","10":"e5779a4c","11":"5039bc62","12":"9a4bd79e","13":"028c8feb","14":"50bba1cd","15":"44fdd5b2","16":"27dc0678","17":"2ce396ca","18":"4a1d5b8a","19":"04654a1e","20":"9f42b593","21":"7647fca5","22":"4ab8948e","23":"a1333efb","24":"7d9bd060","25":"2d0c1682","26":"83840628","27":"06db8eb3","28":"1884bae0","29":"0c7a6d6b","30":"94ac41a3","31":"80369883","32":"894b3884","33":"464e0b3c","34":"c4038011","35":"a2478877","36":"dce01f13","37":"a6e05266","38":"7061c784","39":"770f6b43","40":"e3b0dba4","41":"5b5814b3","42":"f606c470","43":"da8c22e3","44":"996e799b","45":"857ae27a","46":"c6f21a13","47":"53dd6029","48":"a7060c3c","49":"4573893b","50":"600161c8","51":"aedafca1","52":"6ce1200d","53":"b745626d","54":"89f7b3d1","55":"05e07430","57":"ec94c4ed","58":"96b9634f","59":"df7aaeec","60":"e09bee8e","61":"a776dcc4","62":"c145581d","63":"16f5308c","64":"e10f6689","65":"ce09ef9f","66":"4a1b82a8","67":"364c9c95","68":"6a242f68","69":"182d1b33","70":"4fe97d7a","71":"196dd9db","72":"89c253bf","73":"e364b23c","74":"95c2d011","75":"5c75b422","76":"4b0cc1f8","77":"37a864eb","78":"a5b3f4da","79":"ced108d7","80":"b34fbd45","81":"b9627081","82":"8c7e0beb","83":"98650626","84":"32efdadf","85":"5b16c1c6","86":"c0a864a9","87":"8edbaa9c","88":"f85c6e7e","89":"5673deb9","90":"19d0aeaf","91":"17ebd816","92":"120168a4","93":"00b6b689","94":"e8302534","95":"b8e638b3","96":"2c2eedfc","97":"8112dac0","98":"0e4e0857","99":"2b05b453","100":"4908da72","101":"5a887378","102":"a783bd9e","103":"ac39fec0","104":"56f6c158","105":"1b01eb4b","106":"7bf3c8e8","107":"9d1a93a4","108":"a383bf29","109":"9ea9efe5","110":"b36165d0","111":"d19a152f","112":"7129cef3","113":"2020fe1e","114":"1807a21f","115":"05913f8d","116":"31354437","117":"ee9ca5d6","118":"db2e3754","119":"f1a9dee1","120":"da766d86","121":"750a6161","122":"1eda0afc","123":"39b6d5fd","124":"e2b3645d","125":"d2c5a862","126":"2fc4ad95","127":"78aecec4","128":"c2c5d8b5","129":"066adc88","130":"471712e7","131":"19da5886","132":"5f673317","133":"f1da8e42","134":"1f34ea88","135":"14e60037","136":"1af09371","137":"f183e00f","138":"71a26255","139":"2bbae8c1","140":"c8c3d6d3","141":"37db2645","142":"c6e57746","143":"f424849d","144":"69165dc4","145":"0922aedc","146":"5df4747c","147":"78f9e54f","148":"6031954f","149":"a9d462f8","150":"40ac2f39","151":"09d8a4a3","152":"7b157793","153":"ed02c91f","154":"1014347c","155":"137621df","156":"7fce7dfe","157":"bd8b97a7","158":"62c01775","159":"c48c274f","160":"75bc44f5","161":"e7b01ff7","162":"2a2e6c49","163":"3e5c6f66","164":"2cc88f52","165":"06cfa5c2","166":"b7e7ba2c","167":"bacd53a9","168":"9a750d75","169":"f302a3c1","170":"efc85b5c","171":"8b508fb5","172":"27758b05","173":"c7a5caa8","174":"4d363543","175":"79884d1e","176":"8db48f1f","177":"25cca99f","178":"998c7396","179":"2534c2fc","180":"eb2db092","181":"0fd58826","182":"1cb8f42f","183":"5961fd4f","184":"77ce8fd3","185":"f3107b1d","186":"f7a816e2","187":"6b53ee2a","188":"05bc0f8a","189":"23671dcc","190":"d60c2800","191":"6843ec1e","192":"05049067","193":"e0d2e918","194":"d451bd79","195":"e68d9c53","196":"669b33c2","197":"29685fbb","198":"d793e77e","199":"453468cc","200":"556a1583","201":"89319ef1","202":"2b206420","203":"0a832717","204":"9fdb2eea","205":"9d89dd78","206":"0d60c1f9","207":"02b962f2","208":"850d5cc5","209":"788acbb3","210":"9ed4c02b","211":"a999f5c3","212":"0f9b5f9f","213":"f45ba547","214":"9f1cc667","215":"d1eafd79","216":"f217e683","217":"459579ba","218":"12a689a2","219":"1f206e70","220":"836f18e6","221":"a969e3cf","222":"784eacc6","223":"8c2a1cab","224":"8f0673a8","225":"a9d7ae22","226":"a6443553","227":"372a4c7f","228":"ea6494e9","229":"f8959586","230":"a17e1a67","231":"c104e630","232":"28d38808","233":"383db90e","234":"e58e0640","235":"fa29a0bf","236":"eeee7696","237":"10841e2b","238":"bdb728ba","239":"7a4ed67d","240":"8d3c98ba","241":"483d6264","242":"6f68b551","243":"9747ca21","244":"e3346fd5","245":"291d4d39","246":"3b66e185","247":"443bf201","248":"f253ff9d","249":"40ae1a22","250":"d77bfef5","251":"3da688b7","252":"910e1148","253":"0cca0eb0","254":"e6941842","255":"8b7c784c","256":"8d57921a","257":"227db136","258":"7f7f20ab","259":"44a4d3a5","260":"92d4d761","261":"122db2e1","262":"9f9c10b6","263":"b9663cd8","266":"bfa30462","267":"42cb2a13"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push(["ftlp",265,264]);
 	// run deferred modules when ready
 	return checkDeferredModules();
